export class Pessoa {
    nome: string
    tipoPessoa: string
    cpfCnpj: string
    estadoCivil: number
    dataNasc: any
    dataPrimHabil: any
    sexo: string
    fone1: string
    cep: string
    residLogradouro: string
    residNumero: string
    residBairro: string
    residCidade: string
    residUF: string
    email: string
    altura: Number
    peso: Number

    constructor(){

        this.nome = null;
        this.tipoPessoa = null;
        this.cpfCnpj = null;
        this.estadoCivil = null;
        this.dataNasc = null;
        this.dataPrimHabil = null;
        this.sexo = null;
        this.fone1 = null;
        this.cep = null;
        this.residLogradouro = null;
        this.residNumero = null;
        this.residBairro = null;
        this.residCidade = null;
        this.residUF = null;
        this.email = null;

    }

}